import type { StaticImageData } from 'next/image';

import sorobanScanScreenshot from '../../../public/webp/fromPNG/sorobanscan-hp.webp';
import {
  SorobanScanPromoSection,
  StyledButtonLink,
  StyledCard,
  StyledDescription,
  StyledGlow,
  StyledHeading,
  StyledImage,
  StyledImageWrapper,
  StyledLabel,
  StyledTextStack,
} from './styles';

const SOROBAN_SCAN_URL = 'https://sorobanscan.rumblefish.dev/';

export const SorobanScanPromo = () => {
  return (
    <SorobanScanPromoSection width="normal">
      <StyledCard>
        <StyledGlow />

        <StyledTextStack>
          <StyledLabel variant="strong_400">
            Built with Stellar Community Fund
          </StyledLabel>
          <StyledHeading variant="display_md">
            Soroban Scan is live on mainnet!
          </StyledHeading>
          <StyledDescription variant="regular_400">
            Built for the Soroban era - smart contracts, payments, NFTs,
            liquidity pools, all decoded.
          </StyledDescription>
          <StyledButtonLink
            href={SOROBAN_SCAN_URL}
            target="_blank"
            rel="noopener noreferrer">
            Try it now!
          </StyledButtonLink>
        </StyledTextStack>

        <StyledImageWrapper
          href={SOROBAN_SCAN_URL}
          target="_blank"
          rel="noopener noreferrer">
          <StyledImage
            src={(sorobanScanScreenshot as unknown as StaticImageData)?.src}
            alt="Soroban Scan dashboard showing live Stellar network stats and the latest transactions"
          />
        </StyledImageWrapper>
      </StyledCard>
    </SorobanScanPromoSection>
  );
};
